import React  from 'react';

import ColorComponentProto from "./color-proto"

export default function renderColorInFormNew(id, props) {
    return <ColorComponentProto renderMode="form-new" id={id} {...props} />;
}